/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-shadow */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/no-array-index-key */
/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import { memo, FC, useState, Dispatch, SetStateAction, useEffect } from "react";
import { MedicalQuestionnaireAPIData } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import * as _ from "lodash";
import QuestionnaireFields from "src/shared/QuestionnaireFields";
import { Button } from "@mui/material";
import { FormikProps } from "formik";
import { familyMedicalHistory } from "src/helpers/FormDetails/ProposalDetails/resources";
import BMIInformation from "./BMIInformation";
import AddMoreButton from "../AddMoreButton";
import FamilyMedicalHistoryV2 from "./FamilyMedicalHistoryV2";
import CustomizedSwitches from "../CustomToggleButton";

/* eslint-disable react/function-component-definition */
interface Props {
  editable?: boolean;
  formik: FormikProps<any>;
  setErrorJSON: Dispatch<SetStateAction<Record<string, any>>>;
  errorJSON: Record<string, any>;
}

const MedicalLifeStyleV2: FC<Props> = ({ editable, formik, setErrorJSON, errorJSON }) => {
  const questionnaire: MedicalQuestionnaireAPIData.QuestionnaireReducer = useAppSelector(
    (state) => state?.masterdata_reducer?.questionnaire
  );

  const [errorBoundary, setErrorBoundary] = useState(false);

  if (errorBoundary) {
    return (
      <div className="flex flex-col items-center justify-center my-10">
        <p className="font-bold text-lg mb-4">Unable To Fetch Questionnaires!!</p>
        <Button
          variant="contained"
          classes={{ contained: "!rounded-lg" }}
          className="!uppercase m-auto"
          onClick={() => {
            window.location.reload();
          }}
        >
          RETRY
        </Button>
      </div>
    );
  }

  const handleAddingMoreSibling = (setFieldValue: (arg0: string, arg1: any) => void) => {
    const newValue = [...formik?.values?.familyMedicalHistory, familyMedicalHistory];
    setFieldValue("familyMedicalHistory", newValue);
  };

  const getFamilyMedicalLabels = (question: MedicalQuestionnaireAPIData.QuestionnaireReducerKeys) =>
    question?.description?.subQuestions?.questions?.reduce((acc: Record<string, any>, data) => {
      acc[data?.key] = data;
      return acc;
    }, {});

  useEffect(() => {
    if (!formik?.values?.["1001"]) {
      formik?.setFieldValue(`familyMedicalHistory`, [familyMedicalHistory]);
    }
  }, [formik?.values?.["1001"]]);

  console.log("formik values", formik?.values, formik?.errors);
  return (
    <div className="container mx-auto bg-white text-sm font-montserrat normal font-medium leading-50 space-y-5">
      <BMIInformation formik={formik} editable={editable} />
      {_.sortBy(Object.values(questionnaire || {}), ["sequenceID"])?.map(
        (question, index: number) => {
          if (question?.sequenceID === questionnaire["1001"]?.sequenceID)
            return (
              <>
                <div className="flex ">
                  <p className="xl:w-219.25 lg:w-auto md:w-auto sm:w-auto w-67.25 xl:h-24 h-auto flex text-justify xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-39 lg:mr-39 md:mr-39 sm:mr-39 mr-4 ">
                    {question?.description?.heading}
                  </p>

                  <div className="xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4">
                    <CustomizedSwitches
                      isEnabled={editable!}
                      toggleState={formik?.values?.[question?.questionnaireID]}
                      fieldName={question?.questionnaireID}
                      setFieldValue={formik?.setFieldValue}
                    />
                  </div>
                </div>

                {formik?.values?.["1001"] && (
                  <div>
                    {formik?.values?.familyMedicalHistory?.map(
                      (_: any, familyMedicalIndex: number) => (
                        <FamilyMedicalHistoryV2
                          formik={formik}
                          handleChanges={formik?.handleChange}
                          handleBlurs={formik?.handleBlur}
                          error={formik?.errors}
                          touch={formik?.touched}
                          isReview={!editable}
                          setFieldTouch={formik?.setFieldTouched}
                          setFieldValue={formik?.setFieldValue}
                          index={familyMedicalIndex}
                          labels={getFamilyMedicalLabels(question)!}
                          handleRemoveClick={(nomineeIndex: number) => {
                            const filteredData = formik?.values?.familyMedicalHistory.filter(
                              (_: any, innerIndex: number) => innerIndex !== nomineeIndex
                            );
                            formik?.setFieldValue("familyMedicalHistory", filteredData);
                          }}
                        />
                      )
                    )}
                    <div className="w-auto xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4">
                      {editable &&
                        formik?.values?.familyMedicalHistory?.length! <=
                          question?.description?.subQuestions?.addMoreOption?.max && (
                          <AddMoreButton
                            label={`Add More (Max.${question?.description?.subQuestions?.addMoreOption?.max})`}
                            onClick={() => handleAddingMoreSibling(formik?.setFieldValue)}
                          />
                        )}
                    </div>
                  </div>
                )}
                <hr className="border-dashed border-t-2 border-daintree mt-6 mb-6  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4" />
              </>
            );
          return (
            <QuestionnaireFields
              key={index}
              formik={formik}
              question={question}
              setErrorBoundary={setErrorBoundary}
              editable={editable}
              setErrorJSON={setErrorJSON}
              errorJSON={errorJSON}
            />
          );
        }
      )}
    </div>
  );
};

MedicalLifeStyleV2.defaultProps = {
  editable: true
};

export default memo(MedicalLifeStyleV2);
